import { ExternalLink, BookOpen, Calculator, TrendingDown } from 'lucide-react';

export function PricingTab() {
  return (
    <div className="">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Credit Pricing
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Simple, Transparent, Usage-Based Pricing
        </p>
      </div>

      {/* Overview Card */}
      <div className="bg-gradient-to-br from-[#E34290]/10 to-[#E34290]/5 dark:from-[#E34290]/20 dark:to-[#E34290]/10 border border-[#E34290]/20 rounded-lg p-6 mb-6">
        <div className="flex items-start gap-4">
          <div className="p-3 bg-white dark:bg-gray-800 rounded-lg">
            <BookOpen className="h-6 w-6 text-[#E34290]" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              Comprehensive Pricing Guide
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">
              Our pricing model is designed to be straightforward and scalable. You only pay for
              what you use, with credits calculated based on your query specifications.
            </p>
            <a
              href="https://docs.jua.ai/api-v2/query-engine/pricing"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-[#E34290] text-white font-semibold rounded-lg hover:bg-[#E34290]/90 transition-colors duration-150"
            >
              View Detailed Pricing Documentation
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>

      {/* Pricing Features Grid */}
      <div className="grid md:grid-cols-3 gap-4 mb-6">
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-5">
          <div className="flex items-center gap-3 mb-3">
            <div className="p-2 bg-[#E34290]/10 rounded-lg">
              <Calculator className="h-5 w-5 text-[#E34290]" />
            </div>
            <h4 className="font-semibold text-gray-900 dark:text-gray-100">
              Non-Aggregated Forecasts
            </h4>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Credits calculated based on number of locations, model type, forecast horizon, variables
            requested, and number of ICs.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-5">
          <div className="flex items-center gap-3 mb-3">
            <div className="p-2 bg-[#E34290]/10 rounded-lg">
              <TrendingDown className="h-5 w-5 text-[#E34290]" />
            </div>
            <h4 className="font-semibold text-gray-900 dark:text-gray-100">Aggregated Forecasts</h4>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Save significantly on credits by requesting aggregated data. Perfect for regional
            summaries and time-series aggregations.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-5">
          <div className="flex items-center gap-3 mb-3">
            <div className="p-2 bg-[#E34290]/10 rounded-lg">
              <BookOpen className="h-5 w-5 text-[#E34290]" />
            </div>
            <h4 className="font-semibold text-gray-900 dark:text-gray-100">Historical Data</h4>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Access forecasts older than 90 days at 1/1000th the cost for cost-efficient backtesting.
          </p>
        </div>
      </div>
    </div>
  );
}
